import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateAuditRequest,
  CreateAuditResponse,
  GetAuditRequest,
  GetAuditResponse,
  GetAuditStatsRequest,
  GetAuditStatsResponse,
  GetAuditSummaryRequest,
  GetAuditSummaryResponse,
  ListAuditsRequest,
  ListAuditsResponse,
  ReopenAuditRequest,
  ReopenAuditResponse,
  SearchAuditsRequest,
  SearchAuditsResponse,
  UpdateAuditRequest,
  UpdateAuditResponse,
} from 'src/types/helios/Audit';

export const auditService = {
  // Get all audits
  getAll: (data: ListAuditsRequest) => {
    return apiClient.get<ListAuditsResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.AUDITS.LIST(data.businessUnitId)),
      data,
    );
  },

  // Get audit by ID
  getById: (data: GetAuditRequest) => {
    return apiClient.get<GetAuditResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.AUDITS.GET(data.businessUnitId, data.auditId),
      ),
    );
  },

  // Create new audit
  create: (data: CreateAuditRequest) => {
    return apiClient.post<CreateAuditResponse, CreateAuditRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.AUDITS.CREATE(data.businessUnitId)),
      data,
    );
  },

  // Update audit
  update: (data: UpdateAuditRequest) => {
    return apiClient.put<UpdateAuditResponse, UpdateAuditRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.AUDITS.UPDATE(data.businessUnitId, data.auditId),
      ),
      data,
    );
  },

  // Reopen audit
  reopen: (data: ReopenAuditRequest) => {
    return apiClient.post<ReopenAuditResponse, ReopenAuditRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.AUDITS.REOPEN(data.businessUnitId, data.auditId),
      ),
      data,
    );
  },

  // Search audits
  search: (data: SearchAuditsRequest) => {
    return apiClient.post<SearchAuditsResponse, SearchAuditsRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.AUDITS.SEARCH(data.businessUnitId)),
      data,
    );
  },

  // Get audit summary
  getSummary: (data: GetAuditSummaryRequest) => {
    return apiClient.post<GetAuditSummaryResponse, GetAuditSummaryRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.AUDITS.SUMMARY(data.businessUnitId, data.auditId),
      ),
      data,
    );
  },

  // Get audit stats
  getStats: (data: GetAuditStatsRequest) => {
    return apiClient.post<GetAuditStatsResponse, GetAuditStatsRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.AUDITS.STATS(data.businessUnitId)),
      data,
    );
  },
};
